import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ApiResult, ILookup } from 'src/app/shared/model/Index';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Messages } from '@app/modules/compliance/constants/messages';
import { PersonAddressService } from '../../services/personaddress.service';
import { IPersonAddress } from '../../model/personaddress';
import { IStudent } from '@app/modules/compliance/model/student';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { ELookup } from '@app/modules/compliance/constants/eLookup';
import { Guid } from 'guid-typescript';
import { emptyPersonAddress } from '@app/modules/compliance/constants/prepareEmptyObject';
import { environment as env } from '@environments/environment'

@Component({
    selector: 'app-personaddress',
    templateUrl: './person-address.component.html',
    styleUrls:['./person-address.component.css'],
})

export class PersonAddress implements OnInit {
    @Input() student: IStudent;
    @Input() WriteAction:boolean = false;
    isShown: boolean = false;
    isUSAddress: boolean = true;
    displayedColumns: string[] = ['addressType', 'address'];
    dataSource = new MatTableDataSource<IPersonAddress>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    public addressFormGroup: UntypedFormGroup;
    public personAddress: IPersonAddress= emptyPersonAddress();
    public addressTypeList: ILookup[];
    public stateList: ILookup[];
    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _snackBar: MatSnackBar, 
        private _personaddressservice: PersonAddressService) { }
    ngOnInit() {
        this.getActiveLookups(ELookup.AddressType);
        this.getActiveLookups(ELookup.State);
        this.get();
    }
    cancel() {
        this.personAddress = emptyPersonAddress();
        this.fillForm(this.personAddress);
        this.isShown = false;
    }
    add() {
        this.personAddress = emptyPersonAddress();
        this.fillForm(this.personAddress);
        this.isShown = true;
    }
    edit(personAddress:IPersonAddress) {
        this.personAddress = personAddress;
        this.isShown = true;
        this.isUSAddress = this.personAddress.stateId > 0
        this.fillForm(this.personAddress);
    }
    delete(id: Guid) {
        this.deleteAddressById(id);
        this.cancel();
    }
    changeValue(event: any) {
        return event.target.value.length <= 6;
    }
    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.AddressType:
                        this.addressTypeList = result.value;
                        break;
                    case ELookup.State:
                        this.stateList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    public get() {
        this._personaddressservice.get(this.student.personId).subscribe((result: ApiResult<IPersonAddress[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<IPersonAddress>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
    private deleteAddressById(id: Guid) {
        this._personaddressservice.delete(id).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.get()
            }
        }, error => console.error(error));
    }
    private fillForm(personAddress: IPersonAddress) {
        this.addressFormGroup = this._formBuilder.group(
            {
                personId: [personAddress.personId],
                tenantId: [personAddress.tenantId],
                personAddressId: [personAddress.personAddressId],
                addressTypeId: [personAddress.addressTypeId],
                addressLine1: [personAddress.addressLine1],
                addressLine2: [personAddress.addressLine2],
                city: [personAddress.city],
                stateId: [personAddress.stateId],
                stateCode: [personAddress.stateCode],
                provinceName: [personAddress.provinceName],
                postalCode: [personAddress.postalCode],
                countryCode: [personAddress.countryCode],
            });
    }
    public toggleChangeEvent(e)
    {
        this.isUSAddress = e.checked;
        if(e.checked)
        {
            this.addressFormGroup.get("provinceName").setValue('');
            this.addressFormGroup.get("countryCode").setValue('');
            this.addressFormGroup.controls["stateId"].setValidators(Validators.required);
        }
        else
        {
            this.addressFormGroup.get("stateId").setValue(null);
            this.addressFormGroup.controls["stateId"].clearValidators();
        }
        this.addressFormGroup.controls["stateId"].updateValueAndValidity();
    }
    public onSubmit() {
        this.personAddress = this.addressFormGroup.value as IPersonAddress;
        this.personAddress.postalCode = this.personAddress.postalCode.toString();
        if (this.personAddress.personAddressId !== null) {
            this._personaddressservice.put(this.personAddress).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify();
                    this.get();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.personAddress.personId = this.student.personId;
            this.personAddress.tenantId = Guid.parse(env.tenantId).toJSON().value;
            this.personAddress.personAddressId = Guid.createEmpty().toJSON().value;
            this._personaddressservice.post(this.personAddress).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify();
                    this.get();
                }
                else {
                    this.personAddress.personAddressId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify() {
        let snackBarRef = this._snackBar.open(Messages.AddressSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}
